export const MAX_CLIENTS = 5;
export const INVALID_APPLICATION_NAME = /([^A-Za-z0-9@_\s])/gm;
